import React, { Component } from 'react';
import { GECKO_CONSTS } from '../../../ui/constants';
import { GeckoBtns } from '../../../ui/components';

class ToggleButtons extends Component {
  render() {
    const buttons = [
      {
        name: 'Create new',
        type: !this.props.value
          ? GECKO_CONSTS.BTN_TYPE_PRIMARY
          : GECKO_CONSTS.BTN_TYPE_DEFAULT,
        handler: () => {
          this.props.onChange(false);
        },
      },
      {
        name: 'Map to existing',
        type: this.props.value
          ? GECKO_CONSTS.BTN_TYPE_PRIMARY
          : GECKO_CONSTS.BTN_TYPE_DEFAULT,
        handler: () => {
          this.props.onChange(true);
        },
      },
    ];
    return (
      <div>
        <GeckoBtns items={buttons} />
      </div>
    );
  }
}

export default ToggleButtons;
